module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Deadline-Gallipoli.26e1a34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Deadline-Gallipoli.jpg
// module id = JFZQ
// module chunks = 0